export type DfyOrderFormStepId =
  "package" | "addons" | "images" | "branding" | "review";

export interface DfyStepConfig {
  id: DfyOrderFormStepId;
  label: string;
}

export interface DfyStepProps {
  onBack?: () => void;
  onNext?: () => void;
}

export const DFY_FORM_STEPS: DfyStepConfig[] = [
  { id: "package", label: "Package" },
  { id: "addons", label: "Add-ons" },
  { id: "images", label: "Images" },
  { id: "branding", label: "Branding" },
  { id: "review", label: "Review" },
];
